/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForJiraServiceManagement extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForJiraServiceManagement");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForJiraServiceManagement.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForJiraServiceManagement>): ServiceAccountNativeDetailsBaseForJiraServiceManagement {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForJiraServiceManagement(), model);
        ServiceAccountNativeDetailsBaseForJiraServiceManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForJiraServiceManagement>): ServiceAccountNativeDetailsBaseForJiraServiceManagement {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForJiraServiceManagement.newInstance(<ServiceAccountNativeDetailsBaseForJiraServiceManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForJiraServiceManagement) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForJiraServiceManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForJiraServiceManagement): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForJiraServiceManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
